import {
  NEW_DUE_DATE_TEMPLATE,
  NEW_EARLY_REMINDER_TEMPLATE,
  NEW_LATE_PAYMENT_TEMPLATE,
  NEW_RECEIPT_TEMPLATE,
  NEW_SEND_INVOICE_TEMPLATE,
  NEW_ACCOUNT_STATEMENT_TEMPLATE,
  NEW_TEMPLATES,
  SUBMIT_LOADING,
  NEW_SMS_TEMPLATES,
  NEW_DUE_DATE_TEMPLATE_SMS,
  NEW_EARLY_REMINDER_TEMPLATE_SMS,
  NEW_LATE_PAYMENT_TEMPLATE_SMS,
  NEW_RECEIPT_TEMPLATE_SMS,
  NEW_SEND_INVOICE_TEMPLATE_SMS,
  NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS,
  NEW_EMISSION_INVOICE_TEMPLATE_SMS,
  NEW_PAYMENT_RECEIPT_TEMPLATE

} from '../actions/templateActions';

import {
  RESET_ACCOUNT,
  LOG_OUT

} from '../actions/accountActions';


const initialState = {
  all                  : null,
  due_date             : null,
  late_payment         : null,
  receipt              : null,
  reminder             : null,
  send_invoice         : null,
  account_statement    : null,
  isLoadingButton      : false,
  sms_all              : false,
  sms_due_date         : null,
  sms_late_payment     : null,
  sms_receipt          : null,
  sms_reminder         : null,
  sms_send_invoice     : null,
  sms_account_statement: null,
  sms_emission_invoice : null

} // END initialState


export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case NEW_TEMPLATES:
      newState = { all: payload };
      return { ...state, ...newState };

    case NEW_DUE_DATE_TEMPLATE:
      newState = { due_date: payload };
      return { ...state, ...newState };

    case NEW_LATE_PAYMENT_TEMPLATE:
      newState = { late_payment: payload };
      return { ...state, ...newState };

    case NEW_EARLY_REMINDER_TEMPLATE:
      newState = { reminder: payload };
      return { ...state, ...newState };

    case NEW_RECEIPT_TEMPLATE:
      newState = { receipt: payload };
      return { ...state, ...newState };

    case NEW_SEND_INVOICE_TEMPLATE:
      newState = { send_invoice: payload };
      return { ...state, ...newState };

    case NEW_ACCOUNT_STATEMENT_TEMPLATE:
      newState = { account_statement: payload };
      return { ...state, ...newState };

    case NEW_SMS_TEMPLATES:
      newState = { sms_all: payload };
      return { ...state, ...newState };

    case NEW_DUE_DATE_TEMPLATE_SMS:
      newState = { sms_due_date: payload };
      return { ...state, ...newState };

    case NEW_LATE_PAYMENT_TEMPLATE_SMS:
      newState = { sms_late_payment: payload };
      return { ...state, ...newState };

    case NEW_EARLY_REMINDER_TEMPLATE_SMS:
      newState = { sms_reminder: payload };
      return { ...state, ...newState };

    case NEW_RECEIPT_TEMPLATE_SMS:
      newState = { sms_receipt: payload };
      return { ...state, ...newState };

    case NEW_SEND_INVOICE_TEMPLATE_SMS:
      newState = { sms_send_invoice: payload };
      return { ...state, ...newState };

    case NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS:
      newState = { sms_account_statement: payload };
      return { ...state, ...newState };

    case NEW_EMISSION_INVOICE_TEMPLATE_SMS:
      newState = { sms_emission_invoice: payload };
      return { ...state, ...newState };

    case SUBMIT_LOADING:
      return {...state, ...payload };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState }
      return { ...state, ...initialState };


    case NEW_PAYMENT_RECEIPT_TEMPLATE:
      newState = { payment_receipt: payload };
      return { ...state, ...newState };

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/templateReducer.js